import { render, staticRenderFns } from "./BnoxScreen.vue?vue&type=template&id=8d6b8b16&scoped=true"
import script from "./BnoxScreen.vue?vue&type=script&lang=js"
export * from "./BnoxScreen.vue?vue&type=script&lang=js"
import style0 from "./BnoxScreen.vue?vue&type=style&index=0&id=8d6b8b16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d6b8b16",
  null
  
)

export default component.exports